






























import { defineComponent } from '@vue/composition-api'
import ShowBlock from '../components/ShowBlock.vue'
import Paint from '../components/Paint.vue'
import Button from '../components/parts/Button.vue'

export default defineComponent({
  name: 'RobotShowBlock',
  components: {
    ShowBlock,
    Paint,
    Button,
  },
  setup() {
    return {
      dialog: false,
    }
  },
})
